import { render, staticRenderFns } from "./UploadContainer.vue?vue&type=template&id=5ed13d34&scoped=true&"
import script from "./UploadContainer.vue?vue&type=script&lang=js&"
export * from "./UploadContainer.vue?vue&type=script&lang=js&"
import style0 from "./UploadContainer.vue?vue&type=style&index=0&id=5ed13d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed13d34",
  null
  
)

export default component.exports